// extracted by mini-css-extract-plugin
export var colOffset = "twoColumn-module--colOffset--a77c3";
export var leftCol = "twoColumn-module--leftCol--fc95b";
export var twoColContent = "twoColumn-module--twoColContent--87b33";